import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Book, DollarSign, Edit2, Trash2 } from 'react-feather'

// Imports custom
import { TooltipInformation, CustomTableData, LinearLoading, CustomDropDown } from 'common'

export const TableJudicialPremises = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { showForm } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllVehicleReception } = FetchData
    const { dataVehicleReception, loadingFetchVehicleReception } = fetchAllVehicleReception

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificVehicleReception,
        handleClickDeleteVehicleReception,
        handleClickAddPayment,
        handleClickPrintExitPass,
        handleClickPrintReturnCertificate,
        openModal
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "info_fecha_ingreso", headerName: "INGRESO", minWidth: 150, filter: true },
        { field: "identificador", headerName: "ID", minWidth: 100, filter: true },
        { field: "nombre_autoridad", headerName: "AUTORIDAD", minWidth: 250, filter: true },
        { field: "tarifa_aplicada", headerName: "TARIFA APLICADA", minWidth: 200, filter: true },
        { field: "vehicle_placa", headerName: "PLACA", minWidth: 200, filter: true },
        { field: "tarifa_monto", headerName: "MONTO", minWidth: 125, filter: true },
        { field: "dias_transcurridos", headerName: "DIAS", minWidth: 100, filter: true },
        { 
            field: "total_por_dias", headerName: "T. DIAS", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "other_expense_total", headerName: "O. GASTOS", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "total_pagar", headerName: "T. PAGAR", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "info_descuento", headerName: "T. DESCUENTO", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "total_recibido", headerName: "RECIBIDO", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "saldo_total", headerName: "SALDO", minWidth: 150, filter: true,
            cellClass: (params) => {
                return parseFloat(params.value) !== 0 ? 'bg-danger' : 'bg-success';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { field: "info_fecha_cancelado", headerName: "FECHA PAGO", minWidth: 150, filter: true },
        // { field: "vehicle_placa", headerName: "PLACA", minWidth: 100, filter: true },
        // { field: "vehicle_marca", headerName: "MARCA", minWidth: 100, filter: true },
        // { field: "vehicle_linea", headerName: "LINEA", minWidth: 100, filter: true },
        // { field: "vehicle_color", headerName: "COLOR", minWidth: 100, filter: true },
        // { field: "vehicle_modelo", headerName: "MODELO", minWidth: 125, filter: true },
        {
            headerName: 'OPCIONES',
            minWidth: 200,
            cellRenderer: (params) => {
                const { idreception, estado, saldo_total } = params.data

                const formOpeningMode = parseFloat(saldo_total) === 0 ? 'READONLY':'EDITABLE'
                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificVehicleReception(idreception, formOpeningMode)}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickDeleteVehicleReception(idreception)}
                            disabled={formOpeningMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickAddPayment(idreception)}
                        >
                            <ListItemIcon> <DollarSign color="black"/> </ListItemIcon>
                            <ListItemText primary="Pagos" />
                        </MenuItem>
                        {(parseFloat(saldo_total) === 0)&&(
                            <MenuItem
                                // onClick={() => handleClickPrintExitPass(idreception)}
                                onClick={() => openModal(
                                    '',
                                    `DATOS A INGRESAR`,
                                    'TextForExitPass', 
                                    { ...params.data }
                                )}
                            >
                                <ListItemIcon> <Book color="black"/> </ListItemIcon>
                                <ListItemText primary="Pase de salida" />
                            </MenuItem>
                        )}
                        {(parseFloat(saldo_total) === 0)&&(
                            <MenuItem
                                onClick={() => openModal(
                                    '',
                                    `DATOS A INGRESAR`,
                                    'TextForReturnCertificate', 
                                    { ...params.data }
                                )}
                            >
                                <ListItemIcon> <Book color="black"/> </ListItemIcon>
                                <ListItemText primary="Oficio de devolución" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        },
        { field: "usuario_creo", headerName: "CREADO POR", minWidth: 200, filter: true },
        { field: "fecha_creo", headerName: "CREADO EN", minWidth: 200, filter: true },
        { field: "usuario_modifico", headerName: "MODIFICADO POR", minWidth: 200, filter: true },
        { field: "fecha_modifico", headerName: "MODIFICADO EN", minWidth: 200, filter: true },
        { field: "request_id", headerName: "CLAVE", minWidth: 350, filter: true }
    ]

    return (
        <div className='content'>
            {(loadingFetchVehicleReception)&&(<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataVehicleReception}
                columnConfig={columnConfig}
            />
        </div>
    )
}
